module.exports = __webpack_public_path__ + "static/media/1.902fd8de.jpeg";